<template>
  <div class="search-form">
    <div class="search-form__container">
      <div class="search-form__head">
        <span class="search-form__close-icon" @click="hideSearchForm" />
        <span class="search-form__title">
          絞り込み
        </span>
      </div>
      <div class="search-form__body">
        <search-section>
          <template v-slot:title>
            予算
          </template>
          <template v-slot:body>
            <SearchInputGroup
              class="search-form__budget"
              :lower-budget="lowerBudget"
              :higher-budget="higherBudget"
              @inputted-lower-budget="onInputLowerBudget"
              @inputted-higher-budget="onInputHigherBudget"
            />
          </template>
        </search-section>
        <search-section>
          <template v-slot:title>
            カテゴリ
          </template>
          <template v-slot:body>
            <SearchSelectOne
              class="search-form__category"
              prefix-for-label="search-form__category"
              :elements="categories"
              :default-value="selectedCategoryId"
              @clicked="onSelectCategory"
            />
          </template>
        </search-section>
        <search-section>
          <template v-slot:title>
            シーン
          </template>
          <template v-slot:body>
            <SearchSelectOne
              class="search-form__scene"
              prefix-for-label="search-form__scene"
              :elements="scenes"
              :default-value="selectedSceneId"
              @clicked="onSelectScene"
            />
          </template>
        </search-section>
        <search-section>
          <template v-slot:title>
            受け取り方
          </template>
          <template v-slot:body>
            <SearchSelectOne
              class="search-form__receiving-kind"
              prefix-for-label="search-form__receiving-kind"
              :elements="receivingKinds"
              :default-value="selectedReceivingKindId"
              @clicked="onSelectReceivingKind"
            />
          </template>
        </search-section>
        <div class="search-form__counter-section">
          <div v-if="isLoadingItemCount" class="loading-section">
            <SmallLoading />
          </div>
          <div v-else class="search-form__section">
            <div class="search-form__counter counter">
              <span class="hit_count"> {{ hittedItemCount }}件ヒット </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-form__footer">
      <button
        class="btn btn--primary search-form__submit"
        @click="onSubmitSearchForm"
      >
        絞り込む
      </button>
      <button
        class="btn btn--cancel search-form__close"
        @click="hideSearchForm"
      >
        閉じる
      </button>
    </div>
  </div>
</template>
<script>
import SearchSection from './SearchSection'
import SearchInputGroup from './SearchInputGroup'
import SearchSelectOne from './SearchSelectOne'
import SmallLoading from '../../atoms/loadings/SmallLoading'
import axios from 'axios'
import qs from 'qs'
export default {
  components: {
    SearchSection,
    SearchInputGroup,
    SearchSelectOne,
    SmallLoading
  },
  props: {
    lowerBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    higherBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    categories: {
      type: Array,
      required: true
    },
    selectedCategoryId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    scenes: {
      type: Array,
      required: true
    },
    selectedSceneId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    receivingKinds: {
      type: Array,
      required: true
    },
    selectedReceivingKindId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  data() {
    return {
      inputtedLowerBudget: null,
      inputtedHigherBudget: null,
      inputtedSelectedCategoryId: null,
      inputtedSelectedSceneId: null,
      inputtedSelectedReceivingKindId: null,
      hittedItemCount: 0,
      isLoadingItemCount: false
    }
  },
  mounted() {
    this.inputtedLowerBudget = this.lowerBudget
    this.inputtedHigherBudget = this.higherBudget
    this.inputtedSelectedCategoryId = this.selectedCategoryId
    this.inputtedSelectedSceneId = this.selectedSceneId
    this.inputtedSelectedReceivingKindId = this.selectedReceivingKindId
    this.getItemCount()
  },
  methods: {
    hideSearchForm() {
      this.$emit('click-hide')
    },
    onInputLowerBudget(value) {
      this.inputtedLowerBudget = value
      this.getItemCount()
    },
    onInputHigherBudget(value) {
      this.inputtedHigherBudget = value
      this.getItemCount()
    },
    onSelectCategory(selectedId) {
      this.inputtedSelectedCategoryId = selectedId
      this.getItemCount()
    },
    onSelectScene(selectedId) {
      this.inputtedSelectedSceneId = selectedId
      this.getItemCount()
    },
    onSelectReceivingKind(selectedId) {
      this.inputtedSelectedReceivingKindId = selectedId
      this.getItemCount()
    },
    onSubmitSearchForm() {
      this.$emit(
        'submit',
        this.inputtedLowerBudget,
        this.inputtedHigherBudget,
        this.inputtedSelectedCategoryId,
        this.inputtedSelectedSceneId,
        this.inputtedSelectedReceivingKindId
      )
    },
    createParamsObjectFromData() {
      const lowerBudget = this.inputtedLowerBudget
        ? { lower_budget: this.inputtedLowerBudget }
        : {}
      const higherBudget = this.inputtedHigherBudget
        ? { higher_budget: this.inputtedHigherBudget }
        : {}
      const categoryId = this.inputtedSelectedCategoryId
        ? { category_id: this.inputtedSelectedCategoryId }
        : {}
      const sceneId = this.inputtedSelectedSceneId
        ? { scene_id: this.inputtedSelectedSceneId }
        : {}
      const itemReceivingKinds = this.inputtedSelectedReceivingKindId
        ? { item_receiving_kinds: [this.inputtedSelectedReceivingKindId] }
        : {}
      return Object.assign(
        {},
        lowerBudget,
        higherBudget,
        categoryId,
        sceneId,
        itemReceivingKinds
      )
    },
    async getItemCount() {
      this.isLoadingItemCount = true
      try {
        // TODO: delivery 用のエンドポイントを作成する
        const subParams = this.createParamsObjectFromData()
        const res = await axios.get('/api/v1/pickup/items/count', {
          params: { q: subParams },
          paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        this.hittedItemCount = res.data.itemCount
        setTimeout(() => {
          this.isLoadingItemCount = false
        }, 300)
      } catch (error) {
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
      }
    }
  }
}
</script>
